@if (mapItem(); as mapItem) {
    <ui-popup-view-container>
        <ui-detail-image
            [imagePath]="mapItem.thumbnailPath"
            [placeholderPath]="mapItem.placeholderPath"
            [altText]="mapItem.title"
        />
        <ui-detail-content>
            <ui-detail-section>
                <ui-detail-title [title]="mapItem.title"/>
                <ui-detail-address [text]="mapItem.address"/>
            </ui-detail-section>
            @if (mapItem.typeLabel) {
                <ui-detail-tags
                    [tags]="[mapItem.typeLabel]"
                />
            }
            @if (mapItem.shortDescription) {
                <ui-detail-description
                    [htmlDescription]="mapItem.shortDescription"
                />
            }
            @if (isInSidebar) {
                <ui-school-map-item-filtered-measures
                    [mapItem]="mapItem"
                    [isInPopup]="true"
                />
            }
        </ui-detail-content>
    </ui-popup-view-container>
}
